/* eslint-disable react/jsx-props-no-spreading */
import {
  Button, FormControl, InputLabel, MenuItem, Select, TextField, Dialog,
} from '@mui/material';
import React, { useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { toast } from 'react-hot-toast';

const appointmentOptions = [
  { label: 'Restaurants', value: 'Restaurants' },
  { label: 'Indian Restaurants', value: 'Indian Restaurants' },
  { label: 'Seafood Restaurants', value: 'Seafood Restaurants' },
  { label: 'Vegetarian Restaurants', value: 'Vegetarian Restaurants' },
];
const RequestAppointmentForm = ({ data, baseURL, setPopup }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [appointmentFor, setAppointmentFor] = useState('');
  const [preferredDate, setPreferredDate] = useState(dayjs());
  const [note, setNote] = useState('');

  const formData = {
    name,
    email,
    phone,
    request_appointment_reason: appointmentFor,
    preferred_date_time: preferredDate,
    note,
  };
  const handleSubmit = async () => {
    const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/dashboard-review/request-appointment/${data?.address?.company_id}`, formData, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });
    if (res.data.status === 'success') {
      setPopup(false);
      toast.success('Appointment Requested');
    }
    if (res.data.status === 'failure') {
      console.log('RequestAppointment err');
    }
  };

  return (

    <div className="w-full space-y-5 p-6 pt-8 sm:p-10">
      <div className="pr-10 text-lg font-semibold tracking-tight text-slate-900 sm:text-xl">
        Request appointment
      </div>
      <div className="">
        <TextField
          style={{ width: '100%' }}
          label="Name"
          variant="standard"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div>
        <TextField
          style={{ width: '100%' }}
          label="Email"
          variant="standard"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div>
        <TextField
          style={{ width: '100%' }}
          label="Phone"
          variant="standard"
          type="number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>

      <div>
        <TextField
          style={{ width: '100%' }}
          label="Request appointment For"
          variant="standard"
          type="text"
          value={appointmentFor}
          onChange={(e) => setAppointmentFor(e.target.value)}
        />
      </div>

      <div className="w-full space-y-6">
        <div className="mt-7">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              renderInput={(props) => <TextField {...props} sx={{ width: '100%' }} />}
              label="Preferred date and time"
              value={preferredDate}
              onChange={(newValue) => {
                setPreferredDate(newValue);
              }}
            />
          </LocalizationProvider>
        </div>

        <div>
          <TextField
            style={{
              width: '100%',
            }}
            sx={{ '& .MuiFilledInput-root': { borderRadius: '12px 12px 0 0', backgroundColor: '#f8fafc' } }}
            id="filled-multiline-static"
            placeholder="In order to better serve you, please let us know the reason for your visit"
            multiline
            rows={2}
            variant="filled"
            type="text"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </div>

        <div>
          <Button
            variant="contained"
            style={{ width: '100%' }}
            sx={{
              py: 1.5,
              borderRadius: '12px',
              textTransform: 'none',
              fontSize: '15px',
              fontWeight: 500,
              fontFamily: 'inherit',
              boxShadow: '0 1px 2px rgba(15, 23, 42, 0.08)',
              '&:hover': { boxShadow: '0 6px 16px -6px rgba(25, 118, 210, 0.6)' },
            }}
            onClick={handleSubmit}
          >
            Request appointment
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RequestAppointmentForm;
